import { Upload } from 'antd'
import Button from 'components/Button/index'
import Flex from 'components/Flex'
import styled from 'styled-components'

export const Wrapper = styled(Flex)`
  width: 100%;
  min-height: 160px;
  background: ${props => (props?.bgcolor ? props.bgcolor : '#fafafb')};
  border: 1px dashed
    ${props => (props?.borderColor ? props.borderColor : '#E6E7EA')};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  cursor: ${props =>
    props.pointerEventDisable || props.notAllowedCursor
      ? 'not-allowed'
      : 'pointer'};

  &:hover {
    border-color: #1890ff;
  }

  & > * {
    pointer-events: ${props => (props.pointerEventDisable ? 'none' : 'auto')};
  }
`

export const StyledCardDiv = styled(Flex)`
  padding: 12px;
  justify-content: space-between;
  align-items: center;

  height: ${props => (props?.height ? props.height : '63px')};
  background: #ffffff;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  width: ${props => (props?.width ? props.width : '100%')};
`

export const StyledImg = styled(Flex)`
  padding: 10px 10px 10px 0px;
  gap: 5px;
`

export const StyledH2 = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
  margin: 0;
  color: #4d566e;
`

export const StyledP = styled(Flex)``

export const StyledDelete = styled.div`
  cursor: pointer;
  z-index: 1;

  margin-left: ${props => (props?.marginLeft ? '0px' : '23px')};
`

export const StyledUpload = styled(Upload)`
  width: 100%;
  cursor: ${props => (props?.disabled ? 'not-allowed' : 'pointer')};
  .ant-upload {
    width: 100%;
    pointer-events: ${props => (props?.disabled ? 'none' : 'auto')};
  }

  .ant-upload.ant-upload-drag {
    background: transparent;
    border: none;

    &:hover {
      border: none;
    }
  }

  .ant-upload-drag-container {
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`

export const AdjustIcon = styled.div`
  margin-top: ${props => (props?.marginTop ? '7px' : '2px')};
  margin-right: ${props => props?.marginRight && '7px'};
  align-content: ${props => props?.alignContent && 'center'};
`

export const Cirlcle = styled.div`
  width: 6px;
  height: 6px;
  background: #cccfd6;
  border-radius: 50%;
  margin: 0px 13px;
`
export const SmallCirlcle = styled.div`
  width: 3px;
  height: 3px;
  background: #cccfd6;
  border-radius: 50%;
  margin: 0px 5px;
`

export const SpanText = styled.span`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #999fac;
  text-align: center;
`
export const TextWrapper = styled(Flex)`
  padding: ${props => (props.padding ? props.padding : '4px 0')};
  width: 100%;
  text-align: center;
  justify-content: center;
`
export const AddIcon = styled.div`
  margin-top: 5px;
  margin-left: 20px;
  cursor: pointer;
`
export const UploadText = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #3249d7;
  cursor: pointer;
`
export const SmallButtons = styled(Button)`
  width: 38px !important;
  height: 38px !important;
  padding: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  background: white;
  border: 1px solid #e6e7ea;
  position: relative;
  left: 50%;
  transform: translateX(-50%);

  svg {
    width: 20px;
    height: 20px;
    margin: 0;
  }

  &:hover {
    background: white;
    border: 1px solid #e6e7ea;
  }
`

export const VisibleDiv = styled.div`
  cursor: pointer;
  z-index: 1;
  margin-left: 10px;
`

export const BoldText = styled.div`
  font-weight: bold;
  font-size: 20px;
  color: #000000;
  text-align: center;
`

export const Normalext = styled.div`
  font-weight: normal;
  font-size: 15px;
  color: #000000;
  text-align: center;
`

export const AutoFillText = styled.div`
  font-family: Plus Jakarta Sans;
  font-weight: 700;
  font-size: 16px;
  color: #000000;
  span{
    font-family: Plus Jakarta Sans;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
  }
`
